import { render, staticRenderFns } from "./FinanceNotification.vue?vue&type=template&id=5f95b582&"
import script from "./FinanceNotification.vue?vue&type=script&lang=js&"
export * from "./FinanceNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports